/**
 * Appends Next.js `query` as a search string (repeated keys for array values).
 */
export function appendQueryToPath(
  path: string,
  query: Record<string, string | string[] | undefined> | undefined,
): string {
  if (!query) {
    return path;
  }
  const params = new URLSearchParams();
  for (const [key, raw] of Object.entries(query)) {
    if (raw === undefined) {
      continue;
    }
    if (Array.isArray(raw)) {
      for (const v of raw) {
        params.append(key, v);
      }
    } else {
      params.append(key, raw);
    }
  }
  const s = params.toString();
  return s ? `${path}?${s}` : path;
}
